<template>
  <div class="home">
    <Nav/>
    <div class="banner-img">
      <img src="../assets/01.png" />
    </div>
    <div class="main">
      <div class="pro-info">
        <h3>产品介绍</h3>
        <div class="mt40">
          <img class="product-img" src="../assets/product1.png" @click="loanEvent(1)">
          <img class="ml60 product-img" src="../assets/product2.png" @click="loanEvent(2)">
          <img class="ml60 product-img" src="../assets/product3.png" @click="loanEvent(3)">
        </div>
        <div class="mt40">
          <img class="product-img" src="../assets/product4.png" @click="loanEvent(4)">
          <img class="ml60 product-img" src="../assets/product5.png" @click="loanEvent(5)">
          <img class="ml60 product-img" src="../assets/product6.png" @click="loanEvent(6)">
        </div>
      </div>
    </div>
   <Foot />
  </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {
  },
  mounted() {
    this.initBaiduAnalysis();
    this.$nextTick(() => {
      document.getElementsByClassName('home-tab')[0].style.color = '#F29700';
    });
  },
  methods: {
    loanEvent(type) {
      let url;
      switch (type) {
        case 1:
          url = '/EffectiveLoan';
          break;
        case 2:
          url = '/PartnerLoan';
          break;
        case 3:
          url = '/GoldEasyLoan';
          break;
        case 4:
          url = '/Mortgage';
          break;
        case 5:
          url = '/PersonalLoan';
          break;
        case 6:
          url = '/FreightLoan';
          break;
        default:
          url = '/';
          break;
      }
      this.$router.push({ path: url });
    },
    /** 2019/5/15
     *@author:Matt
     *@desc：百度统计
     */
    initBaiduAnalysis() {
      window._hmt = window._hmt || [];
      if (!~location.host.indexOf('kdbank')) return; // 只统计正式环境
      (function () {
        const hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?d1e7ab64f85a3c7d6bfe25bc3dfe3cef';
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
      }());
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @media screen and (max-width: 800px){
  .home{
    .banner-img{
      img{
        width: 100%;
      }
    }
    .main{
      background:rgba(241,241,241,1);
      .pro-info{
        position: relative;
        .black-bl{
          position: absolute;
          top: -17px;
          color: rgba(51,47,43,1);
          font-weight: 500;
          font-size: 26px;
        }
        h3{
          padding-top: 10px;
        }
        .mt40{
          margin-top: 10px;
          img{
            width: 100%;
          }
        }
        .product-img{

        }
      }
    }
  }
  }
  @media screen and (min-width: 800px){
    .home{
      .banner-img{
        img{
          width: 100%;
        }
      }
      .main{
        margin-top: 100px;
        height:880px;
        background:rgba(241,241,241,1);
        .pro-info{
          position: relative;
          text-align: center;
          .black-bl{
            color: #332f2b;
            font-weight: 500;
            font-size: 26px;
            /* left: 16%; */
            /* margin-left: -57rem; */
            margin-left: -57rem;
          }
          h3{
            padding-top: 43px;
            margin-left: -54rem;
          }
          .mt40{
            margin-top: 40px;
          }
          .ml60{
            margin-left: 3.125%;
          }
          .product-img{
            width: 300px;

          }
        }
      }
    }
  }
</style>
